import Form from "components/Form";

const AddPos = () => {
    return (
         <Form type={"posSetting"} />
        
    );
}

export default AddPos;